var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    stroke: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3123 18.2292H16.6665C16.354 18.2292 16.0415 18.4375 15.8332 18.6459L15.4165 19.2709C15.2082 19.5834 14.8957 19.7917 14.5832 19.7917H9.37484C9.06234 19.7917 8.74984 19.5834 8.5415 19.375L8.12484 18.75C7.9165 18.4375 7.604 18.3334 7.2915 18.3334H3.64567C3.02067 18.3334 2.604 18.75 2.604 19.375V20.4167C2.604 21.5625 3.5415 22.5 4.68734 22.5H19.2707C20.4165 22.5 21.354 21.5625 21.354 20.4167V19.375C21.354 18.6459 20.9373 18.2292 20.3123 18.2292V18.2292Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5622 5.72919H5.52051C4.47884 5.72919 3.64551 6.45835 3.64551 7.39585V18.2292",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3123 18.2292V12.7084",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0623 8.33335C13.9582 8.33335 13.9582 8.43752 13.9582 8.43752C13.9582 8.54169 14.0623 8.54169 14.0623 8.54169L14.1665 8.43752C14.1665 8.43752 14.1665 8.33335 14.0623 8.33335",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 8.33335C16.5622 8.33335 16.5622 8.43752 16.5622 8.43752C16.5622 8.54169 16.6663 8.54169 16.6663 8.54169C16.7705 8.54169 16.7705 8.43752 16.7705 8.43752C16.7705 8.43752 16.7705 8.33335 16.6663 8.33335",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2708 8.33335C19.1667 8.33335 19.1667 8.43752 19.1667 8.43752L19.2708 8.54169L19.375 8.43752C19.375 8.43752 19.375 8.33335 19.2708 8.33335",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6665 14.0625C15.729 14.0625 14.7915 13.8542 14.0623 13.4375L11.0415 14.0625L11.6665 11.0417C11.2498 10.2084 11.0415 9.37502 11.0415 8.33335C11.0415 5.20835 13.6457 2.60419 16.7707 2.60419C19.8957 2.60419 22.3957 5.20835 22.3957 8.33335C22.3957 11.4584 19.7915 14.0625 16.6665 14.0625Z",
    strokeWidth: 1.15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.cc2f9a8b2f12f670e3af255d40d648a4.svg";
export { ForwardRef as ReactComponent };